import React, { lazy } from 'react';
import DonutGraphInfo from '../../DonutGraphInfo';
import { titleToolTip } from './titleToolTip';

const layout = window?.$environment?.CURRENT_LAYOUT;
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const RangeInfo = lazy(() => import(`../../RangeInfo`));

export const LGraphContainer = ({ title = '', data, small = false, info = '', cardInfo = '', scoreDes, Styled }) => {
    const titleContent = titleToolTip(title, info, '', false, true);

    return (
        <div>
            <SubHeader
                variant="h1"
                className="statsHeading"
                text={titleContent}
            />
            <div className="infoPosition">
                <div className="card">
                    <span className="text">{cardInfo}</span>
                    <span className="count">{data?.totalDays}</span>
                </div>
            </div>
            <div className="fleet-score-graph2">
                <div className="div60">
                    <DonutGraphInfo
                        isUnPoweredViolation
                        centerTextData={{
                            count: data?.totalScore,
                            text: scoreDes?.actualScore,
                        }}
                        data={data?.chartData}
                    />
                </div>
                <Styled.DIV40 isBottomAlign>
                    <RangeInfo
                        isUnPoweredViolation
                        smallGraph={small}
                    />
                </Styled.DIV40>
            </div>
        </div>
    );
};
